String.prototype.rot13 = function () {
    return this.replace(/[a-zA-Z]/g, function(a){
        return String.fromCharCode(((a=a.charCodeAt())<91?78:110)>a?a+13:a-13);
    });
};

function decryptMailto (event) {
    let link = event.currentTarget;
    let mailtoHref = link.getAttribute('href');
    let rotEmail = mailtoHref.substring('mailto:'.length);

    if (link.classList.contains('email-obf__decoded')) {
        return;
    }

    link.setAttribute('href', 'mailto:' + rotEmail.rot13());
    link.classList.add('email-obf__decoded')
}

document.addEventListener("DOMContentLoaded", function(event) {
    let mailToLinks = document.querySelectorAll('[href^="mailto:"]:not(.email-obf__decoded):not(.dg3sht_mail)');

    if (mailToLinks.length <= 0) {
        return;
    }

    mailToLinks.forEach(function(link) {
        link.addEventListener('click', decryptMailto)
    });
});
